export interface ActivityLogEntry {
  action: string;
  description: string;
  log_date: string;
  user_email: string;
  user_name: string;
}

export interface SupportHubCommentEntry {
  id: number;
  feedback_id: number;
  user_id: number;
  user_name: string;
  team_id?: number | null;
  comment: string;
  isPublic: boolean;
  created_by: string;
  created_date: string;
  modified_by: string;
  modified_date: string;
}

export interface SupportHubTeam {
  team_id: number;
  team_name: string;
  team_description: string;
  usecase_id: number | null;
  workcategory_id: number | null;
}

export interface SupportHubRoleLookup {
  role_id: number;
  role_name: string;
  role_description: string;
  usecase_id: number | null;
  team_id: number | null;
}

export interface SupportHubUserLookup {
  id: number;
  user_id: number;
  user_name: string;
  role_id: number;
  usecase_id: number | null;
  team_id: number | null;
  email_id: string;
  phone_number: string | null;
}

export interface FeedbackFileInfo {
  id?: number;
  feedback_id: number;
  file_name: string;
  file_kb_size: number;
  file?: File;
}

type SupportHubCommonFields = {
  feedback_id?: number;
  title: string;
  description: string;
  requested_user?: number;
  requested_user_name: string;
  creation_date: string;
  company?: string;
  plant?: string;
  shop?: string;
};

type SupportHubEditableSelectionFields = {
  corporate_id: number | null;
  company_id: number | null;
  plant_id: number | null;
  shop_id: number | null;
  usecase_id: number;
  workcategory_id: number | null;
  workcategorytype_id: number | null;
  application_id: number | null;
  rank_id: number | null;
  user_id: number;
  priority_id?: number;
  status_id: number | null;
};

export interface NewSupportHubRequest
  extends SupportHubCommonFields, SupportHubEditableSelectionFields {}

export interface SupportHubRequest extends NewSupportHubRequest {
  version?: string;
  version_id?: number;
  assigned_team_name?: string;
  assigned_team?: number;
  assignedToEmail?: string;
  assigned_user?: number;
  assigned_user_name?: string;
  contractor_user?: number;
  contractor_user_name?: string;
  validated_user?: number;
  validated_user_name?: string;
  validationNote?: string;
  clarificationNote?: string;
  likes_count?: number;
  is_liked: boolean;
  likedByUsers?: { user_id: number; user_name: string }[];
  public_comments_count?: number;
  publicComments?: SupportHubCommentEntry[];
  team_thread_comments_count?: number;
  teamThreadComments?: SupportHubCommentEntry[];
  activityLog: ActivityLogEntry[];
  is_following: boolean;
  followingUsers?: { user_id: number; user_name: string }[];
}

export interface VersionTicket {
  usecase_id: number;
  feedback_id: number;
  corporate_id: number;
  company_id: number;
  plant_id: number;
  shop_id: number;
  workcategory_id: number | null;
  workcategorytype_id: number | null;
  application_id: number | null;
  rank_id: number | null;
  priority_id?: number;
  status_id: number | null;
  title: string;
  description: string;
  creation_date: string;
  requested_user?: number;
  assigned_user?: number;
  assigned_team?: number;
  contractor_user?: number;
  validated_user?: number;
  requested_user_name: string;
  assigned_user_name?: string;
  assigned_team_name?: string;
  validated_user_name?: string;
}

export class ReleaseVersionStatusModel {
  constructor(
    public name: string,
    public colorCode: string,
    public description: string,
    public statusId: number,
    public sortOrder: number
  ) {}
}

export type FeedbackVersion = {
  version_id: number;
  version_name: string;
  version_description: string;
  sortorder: number;
  tickets: VersionTicket[];
  version_status?: string;
  version_status_id?: number;
  usecase_id?: number;
  target_date?: string;
  created_by?: string;
  created_date?: string;
  modified_by?: string;
  modified_date?: string;
};

export type clarificationsEntry = {
    clarification_id: number,
    is_open: boolean,
    request: {
        note: string,
        user_name: string,
        user_email: string,
        user_id: number,
        date: string
    },
    response: {
        note: string | null,
        user_name: string | null,
        user_email: string | null,
        user_id: number,
        date: string
    },
    created_by: string,
    created_date: string,
    modified_by: string,
    modified_date: string
}